import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../../components/PageHeader/PageHeader';
import OpenAndCloseCash from '../../../components/CashRegister/OpenAndCloseCash';

const CashRegisterByUserPage = () => {

  const { t } = useTranslation();

  return (
    <Box p={3}>
      <PageHeader title={t('open_and_close_cash')} subtitle={t('manage_open_and_close_cash')} />
      <Box mt={2}>
        <OpenAndCloseCash forUser={true}/>
      </Box>
    </Box>
  );
};

export default CashRegisterByUserPage;
